import { useEffect, useState } from "react";

const SIDEBAR_COLLAPSED_KEY = "sidebar:collapsed";

export function useSidebarCollapsed() {
  const [collapsed, setCollapsed] = useState<boolean>(() => {
    try {
      return localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === "true";
    } catch {
      return false;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(SIDEBAR_COLLAPSED_KEY, String(collapsed));
    } catch {
      /* ignore quota / privacy mode */
    }
  }, [collapsed]);

  return [collapsed, setCollapsed] as const;
}
